export default {
  data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      acordo: {
        metas: [],
      },
      acordosCopia: [],
      acordoEmpty: null,
      tableHeaderAcordos: [
        {
          name: this.$t('label.codigo'),
          classes: ['pl-12'],
        },
        {
          name: this.$t('label.cliente_dash'),
          classes: [],
        },
        {
          name: this.$tc('label.acordo'),
          classes: [],
        },
        {
          name: this.$tc('label.tipo_acordo'),
          classes: [],
        },
        {
          name: this.$tc('label.solicitante'),
          classes: [],
        },
        {
          name: this.$tc('label.inicio_vigencia', 2),
          classes: [],
        },
        {
          name: this.$tc('label.fim_vigencia', 2),
          classes: [],
        },
        {
          name: this.$tc('label.valor', 1),
          classes: [],
        },
        {
          name: this.$tc('label.acoes', 2),
          classes: [],
        },
      ],
    };
  },
  methods: {
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acordo.js